import { LOAD_RECENTS, ADD_RECENT } from './constants'

const initialState = {
  isFetching: false,
  topics: []
}

export default function recentsReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_RECENTS: {
      return {
        ...state,
        topics: action.topics,
        isFetching: false
      }
    }

    case ADD_RECENT: {
      let topics = state.topics.slice()
      topics = topics.filter(
        (topic) => JSON.stringify(topic) !== JSON.stringify(action.topic)
      )

      if (topics.length > 9) {
        topics.pop()
      }

      return {
        ...state,
        topics: [action.topic, ...topics]
      }
    }

    default: {
      return state
    }
  }
}
